import styled from 'styled-components';

export default styled.div`
  position: absolute;
  width: 100%;
  z-index: 110;
  background: ${props => props.dropdownBackgroundColor ? props.dropdownBackgroundColor : 'rgb(255, 255, 255)'};
  border-radius: 0 0 0.8rem 0.8rem;
  padding: 0.4rem;
  box-shadow: 0 0.3rem 1rem rgba(98, 106, 146, 0.1);
  max-height: 30rem;
  overflow: auto;

  ${props => props.thisStyles}
`;
